import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { SettingsPageService } from "@features/settings/services/settings-page.service";
import { ButtonComponent, SubPageComponent } from "@shared/components";
import { formatTimeInput } from "@shared/functions";
import { RequestState, SettingsResponse } from "@shared/models";
import { GlobalService } from "@shared/services";
import { SkeletonModule } from "primeng/skeleton";
import { Observable, tap } from "rxjs";

@Component({
  selector: "app-proj",
  standalone: true,
  imports: [SubPageComponent, CommonModule, SkeletonModule, ButtonComponent],
  templateUrl: "./proj.component.html",
  styleUrl: "./proj.component.scss",
})
export class ProjComponent implements OnInit {
  globalService = inject(GlobalService);
  settingsPageService = inject(SettingsPageService);

  settings$: Observable<RequestState<SettingsResponse>> = {} as Observable<RequestState<SettingsResponse>>;

  hasChanges: boolean = false;

  originalProjValue: string = "";
  newProjValue: string = "";

  ngOnInit(): void {
    this.getSettings();
  }

  private getSettings(): void {
    this.settings$ = this.settingsPageService.getSettings().pipe(
      tap((response) => {
        if (response.response) {
          this.originalProjValue = response.response.projDefault;
        }
      })
    );
  }

  onKeyDown(keystroke: KeyboardEvent): void {
    const newValue = formatTimeInput(keystroke);
    this.newProjValue = newValue;
    this.checkForChanges();
  }

  checkForChanges(): void {
    if (this.originalProjValue !== this.newProjValue) {
      this.hasChanges = true;
    } else {
      this.hasChanges = false;
    }
  }

  saveSettings(): void {
    this.settingsPageService.saveSettings(this.newProjValue, "proj").subscribe((response) => {
      if (response.response) {
        this.originalProjValue = this.newProjValue;
        this.checkForChanges();
      }
    });
  }
}
